"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.Tabs = void 0;
const external_frame_1 = require("@clearsummit/external-frame");
Object.defineProperty(exports, "Tab", { enumerable: true, get: function () { return external_frame_1.Tab; } });
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return external_frame_1.Tabs; } });
